<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Статусы в приложении</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <div class="overflow-hidden border border-gray-300 rounded-md">
                            <div class="flex items-center bg-gray-100">
                                <div class="w-2/5 py-2 font-bold pl-2">Статус</div>
                                <div class="w-2/5 py-2 font-bold">Отображать как</div>
                                <div class="w-1/5 py-2 font-bold pl-10">Отображать</div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Подтверждение/Оформление</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.submitted_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.submitted"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">В работе</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.in_work_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.in_work"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Оплата</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.prepared_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.prepared"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Оплачен</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.paid_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.paid"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Принято партнером</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.accepted_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.accepted"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Собираем/Готовим</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.awaiting_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.awaiting"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Заказ готов</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.awaiting_ready_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.awaiting_ready"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Курьер</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.delivery_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.delivery"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Консьерж</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.delivery_concierge_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.delivery_concierge"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">В точке встречи</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.meeting_point_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.meeting_point"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Выполнен</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.done_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.done"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                                <div class="w-2/5">Отменен</div>
                                <div class="w-2/5">
                                    <CInput v-model="statuses.canceled_title" class="m-0" />
                                </div>
                                <div class="w-1/5">
                                    <CSwitch
                                        class="ml-5"
                                        color="success"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="statuses.canceled"
                                    />
                                </div>
                            </div>
                        </div>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="saveSettings"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {
        name: 'EntityStatuses',

        data: () => ({
            statuses: {
                submitted: true,
                in_work: true,
                prepared: true,
                paid: true,
                accepted: true,
                awaiting: true,
                awaiting_ready: true,
                delivery: true,
                delivery_concierge: true,
                meeting_point: true,
                done: true,
                canceled: true,
                submitted_title: '',
                in_work_title: '',
                prepared_title: '',
                paid_title: '',
                accepted_title: '',
                awaiting_title: '',
                awaiting_ready_title: '',
                delivery_title: '',
                delivery_concierge_title: '',
                meeting_point_title: '',
                done_title: '',
                canceled_title: '',
            }
        }),

        async mounted() {
            const data = (await this.axios.get(`/default-settings/statuses/${BUSINESS_TYPE.GROCER}`)).data;
            if (data?.id) {
                this.statuses = data;
            }
        },

        methods: {
            async saveSettings() {
                try {
                    this.statuses.entity_type = BUSINESS_TYPE.GROCER;
                    await this.axios.post('/default-settings/statuses/', this.statuses);
                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
            goBack() {
                this.$router.push({ path: '/settings/grocers' });
            },
        },
    };
</script>
